.banner {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xl);
    align-items: flex-start;
}

.intro {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    align-self: stretch;
}

.tipsCard {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
    align-self: stretch;
    padding: var(--spacing-md);
    border-radius: 12px;
    background-color: var(--colorSurfacePrimary);
}

.tipList {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
}
